import CandidateModal from "./CandidateModal";

export default CandidateModal;
